export enum CustomerErrorOrigin {
    GET_CUSTOMERS = 'GET_CUSTOMERS',
    UPSERT_CUSTOMER = 'UPSERT_CUSTOMER',
    CREATE_CUSTOMER_BY_ID = 'CREATE_CUSTOMER_BY_ID',
    GET_QUOTATION_FILE = 'GET_QUOTATION_FILE',
    SEND_ACCOUNT_BALANCE = 'SEND_ACCOUNT_BALANCE',
}

export interface CustomerError {
    type: CustomerErrorOrigin,
    detail: any
}